import { ApiEndpoint } from "utils/baseFetcher";

export const primerInsightsUrl = (slug: string) => {
  const url = new ApiEndpoint(`/api/v2/entities/${slug}/primary-insights`);
  url.searchParams.append("filter[aasm-state]", "published");
  url.searchParams.append("filter[ai-generated-content-type]", "primer");
  url.searchParams.append("page[size]", "1");
  url.searchParams.append("page[number]", "1");
  url.searchParams.append("sort", "-published-at");
  url.searchParams.append(
    "fields[insights]",
    "slug,published-at,ai-generated-content-type"
  );
  return url.href;
};
